import { warn } from './warn';

import type { CurrentUserFetchResponse } from '@api/auth/api.auth.types';

/**
 * Связывает профиль в CarrotQuest с пользователем приложения.
 *
 * Возвращает признак того, что вызов `auth` **поставлен в очередь виджета** —
 * не того, что вендор принял хеш. Виджет отвечает асинхронно и результат
 * авторизации наружу не отдаёт, поэтому большего фронт знать не может.
 * Значение нужно ради порядка вызовов: `identify` вендор разрешает только
 * после `auth`, и обогащать профиль контактами можно лишь следом за ним —
 * см. `carrotQuestIdentifyUser`.
 *
 * @example
 * if (carrotQuestAuth(user, user.user_carrot_quest_hash)) {
 *   carrotQuestIdentifyUser(user);
 * }
 */
export const carrotQuestAuth = (
  user?: CurrentUserFetchResponse,
  userHash?: string,
): boolean => {
  const canAuthenticate = user?.id && userHash;
  if (!canAuthenticate) {
    return false;
  }

  // Без виджета очереди не существует: сообщаем, что вызов не поставлен, иначе
  // следом ушёл бы `identify`, которому не за чем становиться.
  if (!globalThis.carrotquest) {
    return false;
  }

  try {
    globalThis.carrotquest.auth(user.id, userHash);
    return true;
  } catch (error) {
    warn(`Auth failed: ${error}`);
    return false;
  }
};
